import React, {Component} from 'react';
import {Button, Header, Input, Icon, Divider} from 'semantic-ui-react';
import { uploadOtherTemplateDetails, uploadOtherSOCImage } from '../../data/report_api';
import ReportContainer from "../../containers/report_container";
import {DropzoneComponent} from 'react-dropzone-component';

const uuidv1 = require('uuid/v1')

class OriginalReportDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saved: false,
            otherTemplateName: this.props.other_template_name,
            otherTemplateLink: this.props.other_template_link,
            otherTemplateDate: this.props.other_template_date,
            socAvailable:this.props.original_soc_available,
            attachments: [],
            maxNumberOfFilesExceeded: false,
            savedSOC: false,
            uploading:false,
            preLoaded:false,
            notSaved:false
        }
    }

    handleSubmit = () => {
        this.setState({uploading:true});
        let formData = {}
        let formDataDict = {
            original_soc_available:this.state.socAvailable,
            other_template_name: this.state.otherTemplateName,
            other_template_date: this.state.otherTemplateDate,
            other_template_link: this.state.otherTemplateLink,
        }
        formData.report_id = this.props.reportDetails.id;
        formData.other_template_details = JSON.stringify(formDataDict)
        uploadOtherTemplateDetails(formData).then((response) => {
            if (response.success) {
                this.setState({ notSaved:false,saved: true, uploading: false });
                setTimeout(() => {
                    this.setState({saved: false});
                }, 4000);
            }
            else {
                this.setState({ uploading: false });
            }
        });
    };

    handleSubmitSOC = () => {
        this.setState({uploadingSOC:true});
        const formData = new FormData();
        if(this.state.attachments.length > 0 && !this.state.preLoaded){
            formData.append("report_id", this.props.reportId);
            formData.append("images[id]", uuidv1());
            formData.append("images[file]", this.state.attachments[0]);
            uploadOtherSOCImage(formData).then((response) => {
                if(response.success){
                    this.setState({savedSOC: true,uploadingSOC:false,attachments:[]});
                }
                else {
                    this.setState({savedSOC: false,uploadingSOC:false,attachments:[]});
                }
                setTimeout(() => {
                    this.setState({savedSOC: false});
                }, 4000);
            });
        }
        else {
            this.setState({savedSOC: false,uploadingSOC:false,attachments:[]});
        }
    };

    preloadImages = (dropzone) => {
        const socImage = this.props.other_soc;
        if (socImage && socImage.images) {
            const name = socImage.images.id;
            const file = {url: socImage.images['image_path'], name: name, size: 1000000, id: name};
            const imageUrl =socImage.images['image_path'];

            file['serverId'] = name;
            file['accepted'] = true;
            file['status'] = 'success';
            file['upload'] = {
                progress: 100,
                total: 100000,
                bytesSent: 100000
            };
            dropzone.files.push(file);
            this.state.attachments.push(file);
            this.setState({preLoaded:true});
            dropzone.emit("addedfile", file);
            dropzone.emit("thumbnail", file, imageUrl);
            dropzone.emit("complete", file);
        }
    };

    render() {
        let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};
        let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, maxFiles: 1,acceptedFiles:"image/*"};
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
                this.preloadImages(dropzone);
            },
            addedfile: (file) => {
                this.state.attachments.push(file);
                this.setState({fileAdded:true,preLoaded:false});
            },
            removedfile: (file) => {
                this.setState({attachments:[]});
            },
            maxfilesexceeded: (file) => {
                dropZone.removeFile(file);
                this.setState({maxNumberOfFilesExceeded: true});
                setTimeout(() => {
                    this.setState({maxNumberOfFilesExceeded: false})
                }, 10000)
            }
        };
        return (<React.Fragment>
            <div>
            <Header textAlign="left"> Original Report Available? {this.state.saved && <span className="info-success">Saved!</span>} 
            {this.state.notSaved && <span style={{color:"red"}}className="info-negative">Not Saved</span>}</Header>
                <Button primary compact content="Save" loading={this.state.uploading} disabled={this.state.uploading||(this.state.socAvailable == true && ((this.state.otherTemplateName||"").trim() == "" || (this.state.otherTemplateDate||"").trim() == ""))} className="pull-right icon-button" onClick={(e) => {
                    this.handleSubmit()
        }}/> 
                <Button.Group>
                    <Button positive={this.state.socAvailable == true} onClick={() => this.setState({ socAvailable: true,notSaved:true })}>
                        Yes
                    </Button>
                    <Button.Or />
                    <Button negative={this.state.socAvailable == false}  onClick={() =>  this.setState({ socAvailable: false, notSaved:true })}>
                        No
                    </Button>
                </Button.Group>
                </div>
                <Divider/>
        {this.state.socAvailable && <div>
            <Header textAlign="left"> Original Report By: <span style={{color:"red"}}>*</span>  {this.state.saved && <span className="info-success">Saved!</span>}</Header>
            <Input type="text" placeholder='Original Report By' fluid
                   defaultValue={this.props.other_template_name} onChange={(e) => {
                this.setState({otherTemplateName: e.target.value,notSaved:true})
            }}
                />
            <Header textAlign="left"> Original Report Date: <span style={{color:"red"}}>*</span> {this.state.saved && <span className="info-success">Saved!</span>}</Header>
            <Input type="text"  placeholder='Original Report Date' fluid
                   defaultValue={this.props.other_template_date} onChange={(e) => {
                this.setState({otherTemplateDate: e.target.value,notSaved:true})
            }}
            />
                        <Header textAlign="left"> Original Report Photo Link: {this.state.saved && <span className="info-success">Saved!</span>}</Header>
            <Input type="text" placeholder='Original Report Photo Link' fluid
                   defaultValue={this.props.other_template_link} onChange={(e) => {
                this.setState({otherTemplateLink: e.target.value,notSaved:true})
            }}
            />
            <Header textAlign="left"> Original Schedule of Condition {this.state.savedSOC &&
            <span className="info-success">Saved!</span>} <Button primary compact content="Save" disabled={this.state.uploadingSOC} loading={this.state.uploadingSOC}
                                                                  className="pull-right icon-button"
                                                                  onClick={this.handleSubmitSOC}/>{this.state.attachments.length > 0 && !this.state.preLoaded && <span style={{color:"red"}}className="info-negative">Not Saved</span>}</Header>
            {this.state.maxNumberOfFilesExceeded &&
            <p><span className="error-message">Max number of allowed files is 1</span></p>}
            <DropzoneComponent key={this.props.reportId} config={componentConfig}
                               eventHandlers={eventHandlers}
                               djsConfig={djsConfig}/>
        </div>}</React.Fragment>);
    }
}

export default ReportContainer(OriginalReportDetails);


// WEBPACK FOOTER //
// ./src/views/report/original_report_details.js